export default [
    {
        path: '/quotes',
        name: 'Quotes',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
        },
        components: {
            default: () => import('@views/quotes/QuoteIndex.vue'),
        },
    },
    {
        path: '/quotes/:id/view',
        name: 'QuoteView',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
        },
        props: {
            default: (route) => ({ id: route.params.id }),
        },
        components: {
            default: () => import('@views/quotes/QuoteView.vue'),
        },
    },
];
